<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-random"></i> Pindah Gudang
                </div>
                <div class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                    <button v-if="$can('create pindah gudang')" type="button" class="btn btn-primary" @click="addNew">
                        <i class="fas fa-plus-square"></i> Pindah Gudang
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/pindah-gudangs"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="gudang-asal" slot-scope="props">
                            <span>
                                {{ props.rowData.gudang_asal.name }}
                            </span>
                        </template>
                        <template slot="gudang-tujuan" slot-scope="props">
                            <span>
                                {{ props.rowData.gudang_tujuan.name }}
                            </span>
                        </template>
                        <template slot="status" slot-scope="props">
                            <span v-if="props.rowData.status == 'Pengiriman'" class="badge badge-pill badge-warning">{{ props.rowData.status }}</span>
                            <span v-else-if="props.rowData.status == 'Pending Pengirim'" class="badge badge-pill badge-danger">{{ props.rowData.status }}</span>
                            <span v-else-if="props.rowData.status == 'Selesai'" class="badge badge-pill badge-success">{{ props.rowData.status }}</span>
                            <span v-else>-</span>
                        </template>
                        <template slot="action" slot-scope="props">
                            <button type="button" title="View" @click="view(props.rowData)" class="btn btn-link px-1"><i class="fas fa-eye"></i></button>
                            <button v-if="($can('edit pindah gudang') && isBeforeDay(props.rowData.tanggal_berangkat)) || isSuperAdmin" type="button" title="Edit" @click="edit(props.rowData)" class="btn btn-link px-1"><i class="fas fa-edit"></i></button>
                            <button v-if="($can('penerimaan pindah gudang') && isAllowApprove(props.rowData.penerimaan, 1)) || isSuperAdmin" type="button" title="Penerimaan" @click="penerimaan(props.rowData)" class="btn btn-link px-1"><i class="fas fa-vote-yea"></i></button>
                            <button v-if="($can('pelunasan pindah gudang') && isAllowApprove(props.rowData.pelunasan)) || isSuperAdmin" type="button" title="Pelunasan" @click="pelunasan(props.rowData)" class="btn btn-link px-1"><i class="fas fa-file-invoice-dollar"></i></button>
                            <button v-if="isSuperAdmin" type="button" title="Delete" @click="deletePindahGudang(props.rowData)" class="btn btn-link px-1 text-danger"><i class="fas fa-trash-alt"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="editModal" size="lg" :hide-header="true" :hide-footer="true">
            <edit-form :isEdit="isEdit" :value="currentPindahGudang" @saved="saved" @cancel="editModal = false"></edit-form>
		</b-modal>

        <b-modal v-model="viewModal" size="lg" :hide-header="true" :hide-footer="true">
            <viewer :value="currentPindahGudang" @cancel="viewModal = false"></viewer>
		</b-modal>

        <b-modal v-model="showPenerimaan" size="lg" :hide-header="true" :hide-footer="true" no-close-on-backdrop no-close-on-esc>
            <viewer is-penerimaan :value="currentPindahGudang" @saved="saved" @cancel="showPenerimaan = false"></viewer>
		</b-modal>

        <b-modal v-model="showPelunasan" size="lg" :hide-header="true" :hide-footer="true">
            <viewer is-pelunasan :value="currentPindahGudang" @saved="saved" @cancel="showPelunasan = false"></viewer>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import EditForm from './Form';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';
import Viewer from './Viewer';

export default {
    name: "pindah-gudang",

    components: {
        EditForm,
        SearchBar,
        Viewer,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentPindahGudang: null,
            searchText: '',
            searchDate: '',
            searchStatus: '',
            searchGudangAsalId: '',
            searchGudangTujuanId: '',
            editModal: false,
            viewModal: false,
            showScanQrCode: false,
            isPreview: false,
            isEdit: false,
            showPenerimaan: false,
            showPelunasan: false,
            noBatal: false,
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'tanggal_berangkat',
                    title: 'Tanggal Berangkat',
                    sortField: 'tanggal_berangkat',
                    callback: 'formatDate',
                },
                {
                    name: 'penerimaan.created_at',
                    title: 'Tanggal Tiba',
                    sortField: 'tanggal_tiba',
                    callback: 'formatDate',
                },
                {
                    name: '__slot:gudang-asal',
                    title: 'Gudang Asal',
                    sortField: 'gudang_asal_name',
                },
                {
                    name: '__slot:gudang-tujuan',
                    title: 'Gudang Tujuan',
                    sortField: 'gudang_tujuan_name',
                },
                {
                    name: 'bobot_berangkat',
                    title: 'Berat Berangkat (kg)',
                    callback: 'formatNumber',
                },
                {
                    name: 'bobot_tiba',
                    title: 'Berat Tiba (kg)',
                    callback: 'formatNumber',
                },
                {
                    name: 'total_biaya',
                    title: 'Biaya',
                    sortField: 'total_biaya',
                    callback: 'formatNumber',
                },
                {
                    name: '__slot:status',
                    title: 'Status',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                status: this.searchStatus,
                gudang_asal_id: this.searchGudangAsalId,
                gudang_tujuan_id: this.searchGudangTujuanId,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchStatus = search.searchStatus;
            this.searchGudangAsalId = search.searchGudangAsalId;
            this.searchGudangTujuanId = search.searchGudangTujuanId;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchStatus = '';
            this.searchGudangAsalId = '';
            this.searchGudangTujuanId = '';
            this.refresh();
        },

        addNew() {
            this.isEdit = false;
            this.currentPindahGudang = null;
            this.editModal = true;
        },

        edit(rowData) {
            this.isEdit = true;
            this.currentPindahGudang = Object.assign({}, rowData);
            this.editModal = true;
        },

        view(rowData) {
            this.currentPindahGudang = Object.assign({}, rowData);
            this.viewModal = true;
        },

        saved() {
            this.editModal = false;
            this.isEdit = false;
            this.showPenerimaan = false;
            this.showPelunasan = false;
            this.refresh();
        },

        isAllowApprove(data, days) {
            if (!data) {
                return true;
            }
            return this.isBeforeDay(data.created_at, days);
        },

        penerimaan(pindahGudang) {
            this.currentPindahGudang = Object.assign({}, pindahGudang);
            this.showPenerimaan = true;
        },

        pelunasan(pindahGudang) {
            this.currentPindahGudang = Object.assign({}, pindahGudang);
            this.showPelunasan = true;
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/pindah-gudangs/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        deletePindahGudang(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/pindah-gudangs/' + rowData.id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.isLoading = false;
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },
    },
}
</script>
